//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { languageLevels } from '@/utils/jobs';

export default {
  name: 'LanguageListInput',
  props: {
    isEdit: { type: Boolean, default: false },
    item: { type: Object, default: () => {} },
    index: { type: Number, default: 0 },
  },
  data() {
    return {
      languageLevels,
      originItem: {},
      langValues: [
        { label: '聽', value: 'listen' },
        { label: '說', value: 'speak' },
        { label: '讀', value: 'read' },
        { label: '寫', value: 'write' },
        { label: '打字', value: 'typing' },
      ],
    };
  },
  computed: {
    isChange() {
      const allKeys = Object.keys(this.originItem);
      return allKeys.some(key => this.originItem[key] !== this.item[key]);
    },
  },
  mounted() {
    this.originItem = Object.assign({}, this.item);
  },
};
